import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { DocumentValidityStatus } from "web_myplann/Profile/Helpers/paperworkDocument";
import { getPaperworkValidityColors } from "web_myplann/Profile/Helpers/paperworkValidityColors";

type Props = {
	status: DocumentValidityStatus;
	formatted?: string;
};

export const PaperworkValidityBadge: FC<Props> = ({ status, formatted }) => {
	const { palette } = useTheme();
	const { t } = useResource();

	const colors = getPaperworkValidityColors(palette, status);

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={0.6}
			px={1}
			py={0.4}
			flexShrink={0}
			bgcolor={colors.bg}
			borderRadius={"9999px"}
		>
			<Stack width={6} height={6} bgcolor={colors.dot} borderRadius={"50%"} />
			<Typography variant="button" color={colors.text} tabular>
				{formatted
					? t(Resources.Paperwork.Validity.until, { date: formatted })
					: t(Resources.Paperwork.Validity.noExpiration)}
			</Typography>
		</Stack>
	);
};
